import React from "react";
import { Link, NavLink } from "react-router-dom";
import { menuList } from "../../variabili";

const ListMenu = () => {
  function setActive({ isActive }) {
    return isActive ? "navbar__link navbar__link-active" : "navbar__link";
  } 
  return (
    <ul>
      {menuList.map((menuItem) => {
        return (
          <li key={menuItem.id}>
            <NavLink to={menuItem.url} className={setActive}>
              {menuItem.testo}
            </NavLink>
          </li>
        );
      })}
    </ul>
  );
};

export default ListMenu;
